import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { commandesService } from '../services/api';
import { useFormatage } from '../hooks/useAgroshopHooks';
import { getErrorMessage } from '../utils/errorFormatter';

export default function OrderHistory() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [actionError, setActionError] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const navigate = useNavigate();
  const { formatPrix, formatDate } = useFormatage();

  useEffect(() => {
    let mounted = true;

    const fetchOrders = async () => {
      setLoading(true);
      try {
        const data = await commandesService.getHistorique();
        if (!mounted) return;
        setOrders(Array.isArray(data) ? data : data.results || []);
      } catch (e) {
        if (!mounted) return;
        setError(getErrorMessage(e));
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchOrders();
    return () => { mounted = false; };
  }, []);

  if (loading) {
    return (
      <div className="ag-card">
        <h3>Historique des commandes</h3>
        <p>Chargement de votre historique...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="ag-card ag-alert ag-alert-error">
        <h3>Historique des commandes</h3>
        <p>Impossible de charger l'historique : {error}</p>
      </div>
    );
  }

  return (
    <div className="ag-card">
      <h3>Historique des commandes</h3>
      {actionError && (
        <div className="ag-alert ag-alert-error">{actionError}</div>
      )}
      {orders.length === 0 ? (
        <p>Vous n'avez pas encore passé de commande.</p>
      ) : (
        <div className="ag-table-wrapper">
          <table className="ag-table">
            <thead>
              <tr>
                <th>Commande</th>
                <th>Date</th>
                <th>Montant</th>
                <th>Statut</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {orders.slice(0, 10).map((commande) => (
                <tr key={commande.id}>
                  <td>{commande.numero}</td>
                  <td>{formatDate(commande.date_creation)}</td>
                  <td>{formatPrix(commande.montant_total)}</td>
                  <td>{commande.statut_display || commande.statut}</td>
                  <td>
                    {commande.statut === 'confirmee' ? (
                      <>
                        <button
                          type="button"
                          className="ag-btn"
                          onClick={() => navigate(`/cart?commande=${commande.id}`)}
                          disabled={actionLoading}
                        >
                          Payer maintenant
                        </button>
                        <button
                          type="button"
                          className="ag-btn ag-btn--secondary"
                          onClick={async () => {
                            if (!window.confirm('Voulez-vous annuler cette commande ?')) return;
                            setActionError(null);
                            setActionLoading(true);
                            try {
                              const updated = await commandesService.annuler(commande.id);
                              setOrders((prev) => prev.map((o) => (o.id === commande.id ? updated : o)));
                            } catch (e) {
                              setActionError(getErrorMessage(e));
                            } finally {
                              setActionLoading(false);
                            }
                          }}
                          disabled={actionLoading}
                        >
                          Annuler
                        </button>
                      </>
                    ) : (
                      '-'
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
